import { UpdateNote } from '../types/update-note';

/**
 * Picks the content matching the active UI language.
 *
 * Release notes are only written in FR, EN and NL. German users are served English on purpose:
 * it is the natural second language for a German-speaking B2B user, and closer than French.
 * The trailing `||` fallbacks are defensive — the API columns are all NOT NULL.
 */
export function resolveUpdateNoteContent(
  note: UpdateNote,
  activeLang: string,
): string {
  switch (activeLang.toLowerCase()) {
    case 'fr':
      return note.contentFR || note.contentEN;
    case 'nl':
      return note.contentNL || note.contentEN;
    default:
      return note.contentEN || note.contentFR;
  }
}
